import React, { useState } from 'react'
import { Button, Row, Col } from 'react-bootstrap'
import { WebError } from 'utils/errors'

function ContactForm() {
    const [submitted, setSubmitted] = useState(false)
    const [feedback, setFeedback] = useState([])
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [company, setCompany] = useState('')
    const [notes, setNotes] = useState('')

    async function handleErrors(error) {
        if (!error.status || error.status >= 500) {
            setFeedback(['Unexpected error occurred'])
            return
        }

        const errorMessages = [...new Set(
            Object
                .values(error.body)
                .flatMap(error => error)
                .map(error => error.message)
        )]

        setFeedback(errorMessages)
    }

    function sendContactForm() {
        if (email === '' && phone === '') {
            setFeedback(['A valid Phone Number or Email Address is required'])
            return
        } else {
            setFeedback([])
        }

        const options = {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: new URLSearchParams({
                first_name: firstName.trim(),
                last_name: lastName.trim(),
                email: email.trim(),
                phone: phone.trim(),
                company: company.trim(),
                notes: notes.trim()
            })
        }

        fetch(`${process.env.REACT_APP_API_BASE_URL}/customer-contact-us/`, options)
            .then(async res => {
                if (res.status === 200)
                    setSubmitted(true)

                throw new WebError(await res.json(), res.status)
            })
            .catch(handleErrors)
    }

    if (submitted) {
        return (
            <div className="ContactSuccessMessage">
                <p>
                    Thanks! You will hear from us soon.
                    Check out our <a href="https://www.linkedin.com/company/apruvd-llc/" target="_blank" rel="noreferrer">LinkedIn</a> page
                    for current information or feel free to continue browsing the site.
                </p>
            </div>
        )
    }
    else {
        return (
            <div className="ContactForm">
                {
                    feedback.map(item =>
                        <div className="FormFeedback alert alert-danger mt-1">
                            <p>{item}</p>
                        </div>
                    )
                }
                <Row>
                    <Col md={6}>
                        <input
                            name="first_name"
                            tabIndex="1"
                            placeholder="First Name"
                            value={firstName}
                            onChange={e => setFirstName(e.target.value)}
                        />
                        <input
                            name="email"
                            tabIndex="3"
                            placeholder="Email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                        <input
                            name="phone"
                            tabIndex="5"
                            type="text"
                            placeholder="Phone"
                            value={phone}
                            onChange={e => setPhone(e.target.value)}
                        />
                    </Col>
                    <Col md={6}>
                        <input
                            name="last_name"
                            tabIndex="2"
                            type="text"
                            placeholder="Last Name"
                            value={lastName}
                            onChange={e => setLastName(e.target.value)}
                        />
                        <input
                            name="company"
                            tabIndex="4"
                            type="text"
                            placeholder="Business/Organization"
                            value={company}
                            onChange={e => setCompany(e.target.value)}
                        />
                        <input
                            name="notes"
                            tabIndex="6"
                            type="text"
                            placeholder="Interested In"
                            value={notes}
                            onChange={e => setNotes(e.target.value)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="center">
                        <Button type="submit" onClick={sendContactForm}>Get in Touch</Button>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default ContactForm
